"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Web3Provider = void 0;

var _properties = require("@ethersproject/properties");

var _logger = require("@ethersproject/logger");

var _version = require("./_version");

var _jsonRpcProvider = require("./json-rpc-provider");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var logger = new _logger.Logger(_version.version);
var _nextId = 1;

function buildWeb3LegacyFetcher(provider, sendFunc) {
  return function (method, params) {
    // Metamask complains about eth_sign (and on some versions hangs)
    if (method == "eth_sign" && (provider.isMetaMask || provider.isStatus)) {
      // https://github.com/ethereum/go-ethereum/wiki/Management-APIs#personal_sign
      method = "personal_sign";
      params = [params[1], params[0]];
    }

    var request = {
      method: method,
      params: params,
      id: _nextId++,
      jsonrpc: "2.0"
    };
    return new Promise(function (resolve, reject) {
      sendFunc(request, function (error, result) {
        if (error) {
          return reject(error);
        }

        if (result.error) {
          var _error = new Error(result.error.message);

          _error.code = result.error.code;
          _error.data = result.error.data;
          return reject(_error);
        }

        resolve(result.result);
      });
    });
  };
}

function buildEip1193Fetcher(provider) {
  return function (method, params) {
    if (params == null) {
      params = [];
    } // Metamask complains about eth_sign (and on some versions hangs)


    if (method == "eth_sign" && (provider.isMetaMask || provider.isStatus)) {
      // https://github.com/ethereum/go-ethereum/wiki/Management-APIs#personal_sign
      method = "personal_sign";
      params = [params[1], params[0]];
    }

    return provider.request({
      method: method,
      params: params
    });
  };
}

var Web3Provider = /*#__PURE__*/function (_JsonRpcProvider) {
  _inherits(Web3Provider, _JsonRpcProvider);

  var _super = _createSuper(Web3Provider);

  function Web3Provider(provider, network) {
    var _this;

    _classCallCheck(this, Web3Provider);

    logger.checkNew(this instanceof Web3Provider ? this.constructor : void 0, Web3Provider);

    if (provider == null) {
      logger.throwArgumentError("missing provider", "provider", provider);
    }

    var path = null;
    var jsonRpcFetchFunc = null;
    var subprovider = null;

    if (typeof provider === "function") {
      path = "unknown:";
      jsonRpcFetchFunc = provider;
    } else {
      path = provider.host || provider.path || "";

      if (!path && provider.isMetaMask) {
        path = "metamask";
      }

      subprovider = provider;

      if (provider.request) {
        if (path === "") {
          path = "eip-1193:";
        }

        jsonRpcFetchFunc = buildEip1193Fetcher(provider);
      } else if (provider.sendAsync) {
        jsonRpcFetchFunc = buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
      } else if (provider.send) {
        jsonRpcFetchFunc = buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
      } else {
        logger.throwArgumentError("unsupported provider", "provider", provider);
      }

      if (!path) {
        path = "unknown:";
      }
    }

    _this = _super.call(this, path, network);
    (0, _properties.defineReadOnly)(_assertThisInitialized(_this), "jsonRpcFetchFunc", jsonRpcFetchFunc);
    (0, _properties.defineReadOnly)(_assertThisInitialized(_this), "provider", subprovider);
    return _this;
  }

  _createClass(Web3Provider, [{
    key: "send",
    value: function send(method, params) {
      return this.jsonRpcFetchFunc(method, params);
    }
  }]);

  return Web3Provider;
}(_jsonRpcProvider.JsonRpcProvider);

exports.Web3Provider = Web3Provider;